import { MGPFallible } from '@everyboard/lib';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { MoveWithTwoCoords } from '../../jscaip/MoveWithTwoCoords';
import { RulesFailure } from '../../jscaip/RulesFailure';
export class SquarzMove extends MoveCoordToCoord {
    static encoder = MoveWithTwoCoords.getFallibleEncoder(SquarzMove.from);
    static from(start, end) {
        const distance = start.getDistanceToward(end);
        if (distance === 0) {
            return MGPFallible.failure(RulesFailure.MOVE_CANNOT_BE_STATIC());
        }
        else {
            return MGPFallible.success(new SquarzMove(start, end));
        }
    }
    isDuplication() {
        const distance = this.getDistance();
        return distance === 1;
    }
    isJump() {
        const distance = this.getDistance();
        return distance > 1;
    }
}
